<template>
  <div class="my-collect">
    <el-table
      height="calc(100vh - 290px)"
      :data="data"
      v-loading="loading"
      style="width: 100%; margin-bottom: 10px"
    >
      <el-table-column label="序号" width="80" align="center">
        <template slot-scope="scope">{{
          scope.$index + 1 + (page - 1) * 10
        }}</template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="资源标题"
        width="width"
        align="center"
      ></el-table-column>
      <el-table-column label="资源标签" width="width" align="center">
        <template slot-scope="scope">{{
          JSON.parse(scope.row.tag).join(',')
        }}</template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="文件类型"
        width="width"
        align="center"
      >
        <template slot-scope="scope">{{
          getFileType(scope.row.files)
        }}</template>
      </el-table-column>
      <el-table-column
        prop="author"
        label="作者"
        width="width"
        align="center"
      ></el-table-column>
      <el-table-column label="浏览/收藏/下载" width="200" align="center">
        <template slot-scope="scope">
          <div class="data">
            <div class="data-item">
              <img
                class="data-icon"
                style="width: 17px; height: 12px"
                :src="require('../assets/view.png')"
                alt=""
              />
              {{ getDisplayCount(scope.row.views || 0) }}
            </div>
            <div class="data-item">
              <img
                class="data-icon"
                style="width: 15px; height: 14px"
                :src="require('../assets/collect.png')"
                alt=""
              />
              {{ getDisplayCount(scope.row.collect || 0) }}
            </div>
            <div class="data-item">
              <img
                class="data-icon"
                style="width: 14px; height: 14px"
                :src="require('../assets/download.png')"
                alt=""
              />
              {{ getDisplayCount(scope.row.download || 0) }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div class="small-button" @click="toDetail(scope.row.id)">查看</div>
            <div
              class="small-button-cancel"
              @click="cancelCollect(scope.row.id)"
            >
              取消收藏
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      background
      @current-change="onPageChange"
      :current-page="page"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getFileType } from '../utils/utils'
import { collect_list, collect } from '@/api/api'
export default {
  name: 'MyCollect',
  data: () => ({
    data: [],
    page: 1,
    total: 0,
    loading: false,
  }),
  mounted() {
    this.search()
  },
  methods: {
    getFileType,
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    onPageChange(e) {
      this.page = e
      this.search()
    },
    search() {
      this.loading = true
      collect_list(this.page).then((res) => {
        this.loading = false
        console.log('res', res)
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    cancelCollect(id) {
      collect(id).then((res) => {
        this.$message({
          message: '取消收藏成功！',
          type: 'success',
        })
        this.search()
      })
    },
    toDetail(id) {
      // sessionStorage.removeItem('yey-mineMenuIndex')
      this.$router.push(`bookResource?id=${id}`)
    },
  },
}
</script>

<style lang="less" scoped>
.my-collect {
  padding: 20px;
  .small-button {
    width: 56px;
    height: 24px;
    margin-right: 12px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .small-button-cancel {
    width: 74px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #808080;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #808080;
    user-select: none;
    cursor: pointer;
  }
  .data {
    display: flex;
    justify-content: center;
    align-items: center;
    .data-item {
      margin-right: 29px;
      font-size: 14px;
      color: #4c4c4c;
      &:last-child {
        margin-right: 0;
      }
      .data-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
